import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import BootslideEditMenu from '../bootslide-edit-menu'
import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'
import ChartDesignerFeature from '../../model/chart-designer-feature'
import LinesAndBands from './lines-and-bands'
import TrendLineDataSource from './trend-line-data-source'
import ChartDesignerTrendLine from '../../model/chart-designer-trend-line'
import constants from 'scoreboard/components/constants'

/**
 * @typedef TrendLine
 * @property {ChartLine[]|ChartFill[]} children
 */

const FEATURE_KEY = 'trend-line'

/**
 * @property {ChartLine|ChartFill} this.model.children these are pojo
 *     (unwrapped) models
 *
 * @extends LinesAndBands
 */
const TrendLine = LinesAndBands.extend({

	className: LinesAndBands.prototype.className + ' ' + FEATURE_KEY,

	events: _.extend({}, LinesAndBands.prototype.events),

	key: _.constant(FEATURE_KEY),

	/**
	 *
	 * @param {LinesAndBands} options.parent
	 */
	initialize: function (options = {}) {
		if (this.model.children.length === 0) {
			// LinesAndBands will take care of adding fill placeholders
			this.model.children.add(this._createNewTrendLine())
		}
		LinesAndBands.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		LinesAndBands.prototype.render.call(this)
		// Trend line feature views get a fixed height. Set the height in the render
		// method, because it gets overridden in the feature view render method
		// that we are extending.
		this.$el.css('height', '104px')

		return this
	},

	_createNewTrendLine: function() {
		const {axis} = unwrapModel(this.model)
		const line = {
			type: 'line',
			tempId: ChartDesignerFeature.tempId(),
			parentId: this.model.get('id'),
			tempParentId: this.model.get('tempId'),
			axis,
			color: 'gray-medium',
			opacity: constants.DEFAULT_LINE_OPACITY,
			enabled: true
		}
		return line
	},

	secure: function () {
		// Get rid of the stuff that is for lines-and-bands but not trend-line
		// Removing these items has to go here because they get added
		// every time the paint() method is called due to a change.
		this.$('.add-buttons, .click-add-line-container, .info').remove()
	},

	/**
	 * @param {Event} e
	 */
	createEditMenu: function(e) {
		const {type, menuOptions} = this.createEditMenuContext(e)
		if (type === 'line') {
			// Need to delete the entire trend-line feature, not just the line
			menuOptions.deleteFn = () => this.chart.deleteFeature(this.model)
			return new EditLineMenu(menuOptions)
		} else if (type === 'fill') {
			return new LinesAndBands.EditFillMenu(menuOptions)
		}
	}
})

/**
 * Edit menu for a single line.
 * @extends BootslideEditMenu
 */
const EditLineMenu = BootslideEditMenu.extend(/** @lends EditLineMenu.prototype */{

	menuLabel: function() {
		return i18n.get('common.edit2', 'charts.feature.trend-line')
	},

	addTopLevelOptions: function(topLevel) {
		topLevel.push(this.createShowOption())
		topLevel.push(this.createEditLabelOption({
			inputLabel: i18n.get('common.labelWithPrefix', 'charts.feature.trend-line'),
			doneKey: 'common.done'
		}))
		topLevel.push(createDataSourceOption(this.options))
		this.addColorAndOpacityOptions(topLevel)
		topLevel.push(this.createCopyOption(this.labFeature, ChartDesignerTrendLine))
		topLevel.push(this.createDeleteOption(this.options))
	}
}) // EditLineMenu

function createDataSourceOption({model, labFeature, feature}) {
	return BootslideMenu.targetOption('report.designer.setDataSource', () => {
		return new TrendLineDataSource({
			model: feature,
			labFeature,
			chart: model
		})
	})
}

export default TrendLine
export { FEATURE_KEY }
TrendLine.__filename__ = 'charts/edit/analytics/trend-line.js'
